/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './LeilaoDeVeiculosPassoAPasso.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function LeilaoDeVeiculosPassoAPasso() {
  return (
    <>
      <section id="leilao-de-veiculos-passo-a-passo">
        <ContainerHome24>
          <div className="passo-a-passo-textos">
            <h3 className="passo-a-passo-titulo">Passo a passo de comprar um veículo no leilão</h3>
            <p className="passo-a-passo-subtitulo">
              O leilão de veículos Santander pode proporcionar diversas vantagens para você que
              procura pelo veículo próprio:
            </p>
          </div>
          <div className="passo-a-passo-carrossel">
            <p className="passo-a-passo-carrossel-texto">
              Confira um passo a passo resumido sobre como funciona um leilão:
            </p>
            <CustomEmblaCarouselHome24
              // loop
              enableBullets
              detectBulletCount
              //hideOverflow
              enableMobileArrows
              enablePrevArrow
              //autoplay={100000}
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">1</p>
                    <p className="slide-texto">Encontre um parceiro Santander na lista abaixo;</p>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">2</p>
                    <p className="slide-texto">Confira e verifique o estados dos carros;</p>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">3</p>
                    <p className="slide-texto">
                      Escolha um ou mais veículos que pretende propor lances;
                    </p>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">4</p>
                    <p className="slide-texto">
                      Realize o pagamento (você terá um prazo estipulado pelo leiloeiro);
                    </p>
                  </div>
                  <div className={`slide ${className}`}>
                    <p className="slide-numero">5</p>
                    <p className="slide-texto">Retire o veículo.</p>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default LeilaoDeVeiculosPassoAPasso;
